import React from 'react';
import { NAVIGATION } from '../../../config';
import { Anchor } from '../../common';

import WixMPLogo from './images/wixmp-logo.png';

const HeaderLogo = () => {
  return (
    <Anchor href={NAVIGATION.HOME_STATE}>
      <img src={WixMPLogo} width={200} />
    </Anchor>
  );
};

export default HeaderLogo;
